// 30 days in milliseconds
const GRACE_PERIOD = 86400000 * 30;
export const isSubscriptionExpired = (subscription, gracePeriod = GRACE_PERIOD) => {
    const nowInMillis = new Date().getTime();
    const expiry = new Date(subscription.expiry).getTime() + gracePeriod;
    return nowInMillis > expiry;
};
export function filterSubscriptionsFromSet(subscriptions, subscriptionsSet) {
    if (!subscriptionsSet)
        return subscriptions;
    return subscriptions.filter(el => subscriptionsSet?.has(el.name));
}
export function getTransformedAccountSubscriptions(accountSubscriptions, subscriptionsSet) {
    const filteredSubscriptions = filterSubscriptionsFromSet(accountSubscriptions, subscriptionsSet);
    const activeSubscriptions = filteredSubscriptions.filter(el => !isSubscriptionExpired(el));
    const expiredSubscriptions = filteredSubscriptions.filter(el => isSubscriptionExpired(el));
    return {
        accountSubscriptions,
        filteredSubscriptions,
        activeSubscriptions,
        expiredSubscriptions,
    };
}
